
const invalidMessage = "Invalid Email or Password";

const auth = (state = {}, action) => {
  switch (action.type) {
    case 'CLIENT_LOGIN':
    case 'PARTIAL_ARTIST_LOGIN':
      return {
        ...state,
        inProgress: false,
        errors: action.error && invalidMessage
      };

    case 'ARTIST_LOGIN':
      console.log('auth-ARTIST_LOGIN', state)
      return {
        ...state,
        inProgress: false,
        errors: action.error && invalidMessage,
      };
    default:
      return state;
  }
};


export default auth


// WEBPACK FOOTER //
// ./src/reducers/auth.js